import ApiService from "../api";

class DashboardService extends ApiService{
    constructor(){
        super('/portal/dashboard')
    }

    getTotalizadores(){
        return this.post("/getCounters")
    }
}

export default DashboardService;